import Vue from 'vue'

import baseButton from './base-button'
import baseLink from './base-link'
import baseInput from './base-input'
import baseVInput from './base-v-input'
import baseCheckbox from './base-checkbox'
import baseRadio from './base-radio'
import baseInlineLoader from './base-inline-loader'
import baseFullLoader from './base-full-loader'
import baseHeading from './base-heading'
import vSelect from 'vue-select'
import customMessage from './flash-message-custom/custom-message'

import loaderFull from './loader/base-full-loader-plugin'

Vue.component('baseButton', baseButton)
Vue.component('baseLink', baseLink)
Vue.component('baseInput', baseInput)
Vue.component('baseVInput', baseVInput)
Vue.component('baseInlineLoader', baseInlineLoader)
Vue.component('baseFullLoader', baseFullLoader)
Vue.component('baseCheckbox', baseCheckbox)
Vue.component('baseRadio', baseRadio)
Vue.component('baseHeading', baseHeading)
Vue.component('vSelect', vSelect)
Vue.component('customMessage', customMessage)

Vue.use(loaderFull)
